export default __webpack_public_path__ + "static/media/direzione-generale-wallpaper.ee527c76.jpg";